var React = require('react');

var Row = require('../grid/row.js');
var Col = require('../grid/col.js');
var FormItem = require('./formItem.js');
var Button = require('../button/index');
var css = require('./module.scss');

var QueryForm = React.createClass({
    getInitialState: function() {
        return {
            fold:this.props.fold || false,
            foldText:true,
        };
    },
    componentDidMount: function () {
        var me = this;
        // document.onkeydown = function(e) {
        //     if (e.keyCode === 13) {
        //         me.props.onSubmit && me.props.onSubmit(e);
        //     }
        // }
    },

    getValues: function () {
        var values = {},
            _this = this;

        this.props.groups.map(function (group) {
            var i, len, _widget,
                widget = _this.refs.form[group.name];

            if (!widget) {
                return;
            }

            if (Object.prototype.toString.call(widget) == '[object RadioNodeList]') {
                for (i = 0, len = widget.length; i < len; i++) {
                    _widget = widget[i];
                    if (_widget.checked) {
                        values[group.name] = _widget.value;
                        break;
                    }
                }
                return;
            }

            values[group.name] = widget.value;

            if (group.more) {
                values[group.more] = _this.refs.form[group.more].value;
            }
        });

        return values;
    },

    onFold(){
        this.state.foldText = !this.state.foldText
        this.setState()
    },

    render: function () {
        var groups = this.props.groups;
        var me = this;

        var cls = ['fp-query-form'];
        if (this.props.className) {
            cls.push(this.props.className);
        }

        if (!this.props.groups) {
            console.error('groups is undefined');
            return null;
        }

        var totalSpan = 0;
        var len = groups.length;
        var itemSpan = 0;
        groups[len - 1].map(function (item, index) {
            itemSpan = item.span ? item.span : (24 / me.props.col || 8);
            totalSpan += itemSpan;
        });
        return (
            <div className={cls.join(' ')}>
                <form ref="form" onSubmit={this.props.onSubmit}>
                    <fieldset ref="fieldset">
                        {
                            groups.map(function (row, index) {
                                return <Row gutter={me.props.gutter || 0} className='fp-query-row' >
                                    <div style={{'display':(me.state.foldText && me.props.foldRow>0 && index>=me.props.foldRow)?'none':''}}>
                                        {
                                            row.map(function (item) {
                                                return <Col span={item.span ? item.span : (24 / me.props.col || 8)}>
                                                    <FormItem data={item} />
                                                </Col>;
                                            })
                                        }
                                    </div>

                                    {/*
                                        totalSpan < 24 && index == groups.length - 1 ?
                                            <Button text='查 询'
                                                style='primary'
                                                type="submit"
                                                className='fp-query-btn' />
                                            : null
                                    */}
                                    {/*{*/}
                                    {/*    totalSpan < 24 && index == groups.length - 1 ?*/}
                                    {/*    <div className="fp-query-btn-warp">*/}
                                    {/*    {*/}
                                    {/*        <Button text='查 询'*/}
                                    {/*            style='primary'*/}
                                    {/*            type="submit"*/}
                                    {/*            className='fp-query-btn' />*/}
                                    {/*    }*/}
                                    {/*    {*/}
                                    {/*        <Button text='重置'*/}
                                    {/*            style='default'*/}
                                    {/*            className='fp-query-btn'*/}
                                    {/*            onClick={me.props.onReset}/>*/}
                                    {/*    }*/}
                                    {/*        <div style={{'padding': '10px'}}>*/}
                                    {/*            {*/}
                                    {/*                me.state.fold&& <a style={{'color': '#5884F3','text-decoration': 'none','cursor': 'pointer','font-size':'12px'}} onClick={me.onFold}>{me.state.foldText?'更多筛选条件':'收起'}</a>*/}
                                    {/*            }*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*        : null*/}
                                    {/*}*/}
                                </Row>;
                            })
                        }
                        {/* <div className="fp-query-btn-warp">
                        {
                            <Button text='查 询'
                                style='primary'
                                type="submit"
                                className='fp-query-btn' />
                        }
                        {
                            <Button text='重置'
                                style='default'
                                className='fp-query-btn'
                                onClick={this.props.onReset}/>
                        }
                        </div> */}
                        <div className="fp-query-btn-warp" style={{'height':'unset','position':'unset','text-align':'right','padding':'0 15px'}}>
                            {<label style={{'padding': '10px'}}>
                                {
                                    me.state.fold && <a style={{
                                        'color': '#5884F3',
                                        'text-decoration': 'none',
                                        'cursor': 'pointer',
                                        'font-size': '12px'
                                    }} onClick={me.onFold}>{me.state.foldText ? '更多筛选条件' : '收起'}</a>
                                }
                            </label>}
                            {
                                <Button text='查 询'
                                        style='primary'
                                        type="submit"
                                        className='fp-query-btn' />
                            }
                            {
                                <Button text='重置'
                                        style='default'
                                        className='fp-query-btn'
                                        onClick={this.props.onReset}/>
                            }

                        </div>
                    </fieldset>
                </form>

            </div>
        );
    }

});

module.exports = QueryForm;



// WEBPACK FOOTER //
// ./component/queryform/queryform.js